import { Map, Contrast, Grid3x3, Satellite, Rotate3d, Video } from "lucide-react"
import type { ReactNode } from "react"

const STYLE_ITEMS: { id: string; label: string; icon: ReactNode }[] = [
  { id: "street", label: "Plan", icon: <Map className="w-5 h-5" /> },
  { id: "mono", label: "Mono", icon: <Contrast className="w-5 h-5" /> },
  { id: "cadastre", label: "Cadastre", icon: <Grid3x3 className="w-5 h-5" /> },
  { id: "satellite", label: "Satellite", icon: <Satellite className="w-5 h-5" /> },
  { id: "3d", label: "3D", icon: <Rotate3d className="w-5 h-5" /> },
  { id: "streetview", label: "Street", icon: <Video className="w-5 h-5" /> },
]

interface MapStyleSelectorProps {
  activeStyle: string
  onChange: (style: string) => void
  compact?: boolean
}

export const MapStyleSelector = ({ activeStyle, onChange, compact }: MapStyleSelectorProps) => {
  return (
    <div className="absolute top-2 right-2 z-10" data-tour-step="map-style">
      <div
        className={`flex gap-0.5 bg-white/95 backdrop-blur-sm rounded-xl p-2 map-panel-shadow ${compact ? "flex-col" : "items-center"}`}
      >
        {STYLE_ITEMS.map((style) => (
          <button
            key={style.id}
            disabled={activeStyle === style.id}
            title={style.label}
            onClick={() => onChange(style.id)}
            className={`flex flex-col items-center justify-center w-12 h-12 rounded-lg transition-all duration-150 btn-press ${
              activeStyle === style.id
                ? "bg-primary text-white shadow-sm shadow-primary/30"
                : "text-gray-500 hover:bg-gray-100 hover:text-gray-800 cursor-pointer"
            }`}
          >
            {style.icon}
            <span className="text-xs leading-tight mt-0.5 font-medium truncate max-w-full px-0.5">{style.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
